import "web-animations-js/web-animations-next.min.js"

// allows for being called with `async`
if (document.readyState !== "loading") {
  main()
} else {
  window.addEventListener("DOMContentLoaded", main)
}

function main() {
  manageBackgrounds()
}

async function manageBackgrounds() {
  const container_selector = ".slideshow"
  const image_selector = "img"

  try {
    const container = await document.querySelector(container_selector)
    if ((await container.querySelectorAll(image_selector)).length <= 1) {
      throw "Not enough images in slideshow - exiting."
    }
    const animate = async () => {
      const first_image = await container.querySelector(`${image_selector}:first-child`)
      const second_image = await container.querySelector(`${image_selector}:nth-child(2)`)
      const animateOptions = {
        delay: 4000,
        duration: 2000,
        fill: "forwards"
      }
      const first_animation = first_image.animate([
        {
          opacity: 1
        }, {
          opacity: 0
        }
      ], animateOptions)
      const second_animation = second_image.animate([
        {
          opacity: 0
        }, {
          opacity: 1
        }, {
          opacity: 1
        }
      ], animateOptions)
      await Promise.all([first_animation.finished, second_animation.finished])
      first_animation.cancel()
      second_animation.cancel()
      container.appendChild(first_image)
      animate()
    }
    animate()
  } catch (e) {
    console.error(e)
  }
}



// WEBPACK FOOTER //
// ./dev/scripts/scripts.js